export function clampPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

export function historyStaggerStyle(index, enabled, options = {}) {
  if (!enabled) {
    return {
      animation: "none",
      animationDelay: "0ms",
    };
  }
  const step = Number(options.stepMs ?? 30);
  const maxDelay = Number(options.maxDelayMs ?? 240);
  const delay = Math.min(Math.max(0, Number(index) || 0) * step, maxDelay);
  return {
    animation: "historyRise 0.42s cubic-bezier(0.22, 1, 0.36, 1) both",
    animationDelay: `${delay}ms`,
  };
}

export function historyBarFillStyle(percent, enabled, color) {
  const width = clampPercent(percent);
  return {
    width: `${Number.isInteger(width) ? width : Number(width.toFixed(2))}%`,
    height: "100%",
    background: color,
    borderRadius: 4,
    transition: enabled
      ? "width 0.62s cubic-bezier(0.22, 1, 0.36, 1)"
      : "none",
  };
}

export function mergeStyles(...styles) {
  return Object.assign({}, ...styles.filter(Boolean));
}
